'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MatchTooltip = require('shared/components/MatchTooltip');

var _MatchTooltip2 = _interopRequireDefault(_MatchTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContent = function getContent(_ref) {
  var type = _ref.type,
      match = _ref.match;

  var jobHot = require('shared/images/hot.png');

  if (type === 'match') {
    var _class = ['c-tooltip', match ? '' : 'no-match', 'down'].join(' ');
    return _react2.default.createElement(_MatchTooltip2.default, {
      match: match,
      _class: _class,
      matchMeComponent: function matchMeComponent() {
        return _react2.default.createElement(
          'div',
          { className: 'no-match' },
          _react2.default.createElement(
            'span',
            null,
            'Match'
          ),
          _react2.default.createElement(
            'em',
            null,
            'me'
          )
        );
      },
      matchComponent: function matchComponent(parsedMatch) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'em',
            null,
            parsedMatch
          ),
          _react2.default.createElement(
            'span',
            null,
            'Match'
          )
        );
      }
    });
  } else if (type === 'hot_job') {
    return _react2.default.createElement(
      'div',
      { className: 'c-tooltip down with-image' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', { src: jobHot, alt: 'Hot Job' }),
        'Hot Job'
      )
    );
  }

  return 'Unsupported type ' + type;
};

function Tooltip(_ref2) {
  var tooltip = _ref2.tooltip;

  return getContent(tooltip);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Tooltips/Tooltip.jsx
// module id = 1267
// module chunks = 0